module.exports = __webpack_public_path__ + "assets/images/novasport_3.9434046f2343efb1d56f17ada567896d.png";